<template>
    <div :class="cardClass" v-show="!closed">
        <slot name="top"/>
        <div :class="headerClass" v-if="!!$slots.header || title" @click="$emit('header-click')">
            <slot name="header">
                <div class="tools" v-if="!!$slots.tools">
                    <slot name="tools"/>
                </div>
                <span class="title">{{ title }}</span>
                <span class="card-subtitle" v-if="subtitle">{{ subtitle }}</span>
            </slot>
        </div>
        <slot name="body" v-if="!folded"><div :class="bodyClass"><slot/></div></slot>
        <div :class="footerClass" v-if="!!$slots.footer" v-show="!folded"><slot name="footer"/></div>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            subtitle: String,
            closed: Boolean,
            folded: Boolean,

            flat: Boolean,
            border: Boolean,
            table: Boolean,
            divider: Boolean,
            featured: Boolean,
            align: String,
            borderColor: String,
            headerColor: String,
            fullColor: String,
            headerContrast: Boolean,
            bodyContrast: Boolean,
            footerContrast: Boolean,
        },

        computed: {
            cardClass() {
                return {
                    card: true,
                    'card-flat': this.flat,
                    'card-border': this.border,
                    'card-table': this.table,
                    'card-contrast': this.headerContrast || this.headerColor || this.bodyContrast || this.footerContrast,
                    [`card-full-color card-full-${this.fullColor}`]: !!this.fullColor,
                    [`card-border-color card-border-color-${this.borderColor}`]: !!this.borderColor,
                    'text-center': this.align === 'center',
                    'text-right': this.align === 'right',
                };
            },

            headerClass() {
                return {
                    'card-header': true,
                    'card-header-contrast': this.headerContrast || this.headerColor,
                    'card-header-divider': this.divider,
                    'card-header-featured': this.featured,
                    [`card-full-${this.headerColor}`]: this.headerColor,
                };
            },

            bodyClass() {
                return {
                    'card-body': true,
                    'card-body-contrast': this.bodyContrast,
                };
            },

            footerClass() {
                return { 'card-footer': true, 'card-footer-contrast': this.footerContrast };
            },
        },
    };
</script>
